import api from '../../config/axios.js';
import { apiError } from '@/services/registrationExperience';

let insightsRequestId = 0;
let cardsRequestId = 0;
let hoursRequestId = 0;

const emptyCards = () => ({
    year: null, month: null, scheduled: 0, canceled: 0, new_clients: 0,
    amount_received: '0,00', amount_sold: '0,00', tax: '0,00', expense_value: '0,00',
    attendant_of_the_month: { name: '', qtd_services: 0, amount_received: '0,00' },
});
const emptyHours = () => Object.fromEntries(Array.from({ length: 24 }, (_, hour) =>
    [`${String(hour).padStart(2, '0')}:00`, { scheduled: 0, canceled: 0 }]));

const state = {
    dashboardInsights: null,
    dashboardInsightsLoading: true,
    dashboardInsightsError: '',
    dashboardInsightsQuery: { month: null, year: null },
    metricsMonthSendAndReceivedHour: emptyHours(),
    cardsDashboardMonth: emptyCards(),
}
const getters = {
    getDashboardInsights: state => state.dashboardInsights,
    getDashboardInsightsLoading: state => state.dashboardInsightsLoading,
    getDashboardInsightsError: state => state.dashboardInsightsError,
    getDashboardInsightsQuery: state => state.dashboardInsightsQuery,
    getCardsDashboardMonth: state => state.cardsDashboardMonth,
    getMetricsMonthSendAndReceivedHour: state => state.metricsMonthSendAndReceivedHour,
}
const actions = {
        async fetchDashboardInsights({ commit }, params) {
            const query = { month: params?.month ?? null, year: params?.year ?? null };
            const requestId = ++insightsRequestId;
            commit('setDashboardInsightsQuery', query);
            commit('setDashboardInsightsLoading', true);
            commit('setDashboardInsightsError', '');
            try {
                const { data } = await api.axios.get(`/api/metrics/insights/month/${query.month}/${query.year}`);
                if (!data?.automation || !data?.satisfaction) throw new Error('Invalid dashboard indicators response');
                if (requestId === insightsRequestId) commit('setDashboardInsights', data);
            } catch (error) {
                if (requestId === insightsRequestId) {
                    commit('setDashboardInsights', null);
                    commit('setDashboardInsightsError', apiError(error, 'Não foi possível carregar os indicadores.'));
                }
            } finally {
                if (requestId === insightsRequestId) commit('setDashboardInsightsLoading', false);
            }
        },
    // BUSCANDO MÉTRICAS DOS CARDS MÊS ATUAL
        async fetchCardsDashboardMonth({ commit, dispatch, state }, params){
                const requestId = ++cardsRequestId;
                let query = params || { month: state.cardsDashboardMonth.month, year: state.cardsDashboardMonth.year };
                const response = await api.axios.get(`/api/metrics/cards/month/${params ? params.month : null}/${params ? params.year : null}`).catch((error) => {
                    console.log("tratar erro de metricas do mes atual", error);
                });
                if (requestId !== cardsRequestId) return;
                if (response && response.data) {
                    commit('setCardsDashboardMonth', response.data);
                    // Follow the resolved dashboard period, including at month/year boundaries.
                    query = { month: response.data.month ?? null, year: response.data.year ?? null };
                } else {
                    commit('setCardsDashboardMonth', emptyCards());
                }
                await dispatch('fetchDashboardInsights', query);
        },
    // BUSCANDO MÉTRICAS DOS HORÁRIOS ENVIADO VS RECEBIDO MÊS ATUAL
        async fetchMetricsMonthScheduleCategoriesHour({ commit }, params) {
            const requestId = ++hoursRequestId;
            try {
                const { data } = await api.axios.get(`/api/metrics/hours/month/${params?.month ?? null}/${params?.year ?? null}`);
                if (requestId === hoursRequestId) commit('setMetricsMonthSendAndReceivedHour', data);
            } catch (error) {
                if (requestId === hoursRequestId) commit('setMetricsMonthSendAndReceivedHour', emptyHours());
            }
        },

}

const mutations = {
        resetVisibleDashboard(state) {
            ++insightsRequestId; ++cardsRequestId; ++hoursRequestId;
            state.cardsDashboardMonth = emptyCards();
            state.metricsMonthSendAndReceivedHour = emptyHours();
            state.dashboardInsights = null;
            state.dashboardInsightsLoading = true;
            state.dashboardInsightsError = '';
        },
        setDashboardInsights: (state, data) => { state.dashboardInsights = data; },
        setDashboardInsightsLoading: (state, loading) => { state.dashboardInsightsLoading = loading; },
        setDashboardInsightsError: (state, error) => { state.dashboardInsightsError = error; },
        setDashboardInsightsQuery(state, query) {
            if (state.dashboardInsightsQuery.month !== query.month || state.dashboardInsightsQuery.year !== query.year) {
                state.dashboardInsights = null;
            }
            state.dashboardInsightsQuery = query;
        },
    // BUSCANDO MÉTRICAS DOS CARDS MÊS ATUAL
        setCardsDashboardMonth: function(state, data){
            state.cardsDashboardMonth = data;
        },
    // BUSCANDO MÉTRICAS DOS HORÁRIOS ENVIADO VS RECEBIDO MÊS ATUAL
        setMetricsMonthSendAndReceivedHour: function(state, data){
            state.metricsMonthSendAndReceivedHour = data;
        },
}
export default {
    state,
    getters,
    actions,
    mutations
}
